// import Food from './Food';

export default {
  // component: Food,
  component: load(() => import(/* webpackChunkName: "Feed-Food" */ './Food')),
  priority: 14,
  permissions: ['FeedingConsoleMenu/FoodProgramMenu'], // TODO permission
  name: app.translate('routes.home.feed.Food'),
  icon: 'food',
  drawer: true,
};


